export default {
    props: {
      bianji:'',
    }
    ,
    data() {
      return {
        
        radio: '',
        search:'',
        shop_search:'',

        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',

        gengxin:'',

      }
    },
    methods: {
          // 获取项目信息
          getshop_search(){
            this.$post('projects/shop_search', {
              offset:0,  
              length:999,
               token: this.$store.state.authority_management,
            }).then(res => {
              this.shop_search = res.data.result.data
            })
          },
          // 获取辅导员信息
          getsearch(){
            this.$post('instructor/search', {
              offset:0,  
              length:999,
               token: this.$store.state.authority_management,
            }).then(res => {
              this.search = res.data.result.data
            })
          },
         

            // 提示消息
            tishi(text) {
            this.$message.error(text);
          },
          // 成功消息
          success(text) {
                this.$message({
                  message: text,
                  type: 'success'
                });
              },
          //更新数据库
          gengxinshuju(){
          let fl = false
          let text = "请输入"
         

            if (this.value2 == this.gengxin.project_name) {
              this.value2 = this.gengxin.project_id
            }
            if (this.value3 == this.gengxin.instructor_name) {
              this.value3 = this.gengxin.instructor_id
            }



                // 校验
          if(this.value1 == ''|| this.value1 == null){
            text = text + '__[班级名称]'
            } 
            if(this.value2 == '' || this.value2 == null ){
            text = text + '__[项目名称]'
            } 
            if(this.value3 == ''  || this.value3  == null){
            text = text + '__[辅导员]'
            } 
            if(this.value5 == '' || this.value5 == null){
            text = text + '__[开班时间]'
            }
            if(text == '请输入'){
            fl = true
            }else{
            this.tishi(text)
            }

            if(fl){

                this.$post('class/edit', {
                  id:this.gengxin.id,
                  name:           this.value1,
                  project_id:     this.value2,
                  instructor_id:  this.value3,
                  start_time:     this.value5,
                  token: this.$store.state.authority_management,
                }).then(res => {
                  if(res.data.status=='success'){
                    this.success('修改成功！')
                  }else{
                    this.tishi('修改失败！')
                  }
                  
                })
              }
          },
          //获取页面跳转参数
          getinpt(){
            this.gengxin = this.bianji;
            this.value1 = this.gengxin.name
            this.value2 = this.gengxin.project_name
            this.value3 = this.gengxin.instructor_name
            this.value5 = this.gengxin.start_time
         }
       },

       created(){

         this.getinpt();
         this.getshop_search();
         this.getsearch();

       },
     }